import { render, staticRenderFns } from "./vehicleType.vue?vue&type=template&id=d4f53720&scoped=true&"
import script from "./vehicleType.vue?vue&type=script&lang=js&"
export * from "./vehicleType.vue?vue&type=script&lang=js&"
import style0 from "./vehicleType.vue?vue&type=style&index=0&id=d4f53720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f53720",
  null
  
)

component.options.__file = "vehicleType.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VLayout,
})
